import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4920bcc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login flex h-full" }
const _hoisted_2 = { class: "left relative w-7/12 h-full flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layer h-full w-full z-10 flex absolute top-0 bg-primary-900" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background h-full w-full z-0 flex absolute top-0" }, null, -1))
const _hoisted_5 = { class: "right flex w-5/12 h-full bg-white" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-black-700" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Accedi al pannello di controllo Sultan")
], -1))
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "block text-primary-700 font-bold mb-2 float-left",
  for: "email"
}, "Email", -1))
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "block text-primary-700 text-sm font-bold mb-2 float-left",
  for: "password"
}, "Password", -1))
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  style: {"display":"inherit","margin-bottom":"2px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SultanLogo = _resolveComponent("SultanLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SultanLogo, { class: "logo color-white z-20 object-none object-center relative m-auto" }),
      _hoisted_3,
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("form", {
        class: "form m-auto",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.performLogin()), ["prevent"]))
      }, [
        _hoisted_6,
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              class: "appearance-none rounded w-full py-2 px-3 text-black-700 mb-3 leading-tight bg-blue-50 focus:outline-none focus:shadow-outline",
              id: "email",
              type: "text",
              placeholder: "Inserisci qui la tua email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              class: "appearance-none rounded w-full py-2 px-3 text-black-700 mb-3 leading-tight bg-blue-50 focus:outline-none focus:shadow-outline",
              id: "password",
              type: "password",
              placeholder: "Inserisci qui la tua password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "bg-primary-900 text-white font-bold py-2 px-4 rounded w-full hover:bg-blue-700 focus:outline-none focus:shadow-outline",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.performLogin())),
              disabled: _ctx.isAuthenticating
            }, [
              (_ctx.isAuthenticating)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_16))
                : _createCommentVNode("", true),
              _createTextVNode("Sign In")
            ], 8, _hoisted_12)
          ])
        ])
      ], 32)
    ])
  ]))
}